import { render, staticRenderFns } from "./ExchangeDialogComponent.vue?vue&type=template&id=1a8c881e&scoped=true"
import script from "./ExchangeDialogComponent.vue?vue&type=script&lang=js"
export * from "./ExchangeDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8c881e",
  null
  
)

export default component.exports